module.exports = __webpack_public_path__ + "static/media/pe.49d2163f.svg";